import JQueryView, { on } from '../../../../common/views/jqueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');
  }

  @on({ event: 'change', selector: '#display_password' })
  onChangeDisplayPassword() {
    const displayPassword = $('#display_password').filter(':checked').val();
    $('#user_password').attr({
      type: displayPassword != null ? 'text' : 'password',
    });
  }
}
